(ns frontend.view.nev.kyc.process-status-views.wip-status
  (:require
   [basic-components.inputs.footprint :refer [editor]]
   [common.languages :as languages]
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.kyc-process :as kyc-process]
   [common.schema.entities.workspace.kyc.templates.template-registry :as template-registry]
   [frontend.actions.kyc-process :as kyc-process-actions]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [frontend.view.nev.kyc.process-status-views.edit-view :as edit-view]
   [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
   [ui.components.button.view :as button]))

(defn submit-for-review!
  [entity state-atom]
  (kyc-process-actions/*->submit-for-review!
   {:kyc-process-id (:db/id entity)}
   (fn [_resp]
     (swap! state-atom assoc :submitted-for-review true)
     (fu/timeout 3000
                 #(swap! state-atom dissoc :submitted-for-review)))
   (fn [resp]
     (logging/error "Failed to submit KYC for review " resp))))

(defn complete!
  [entity answers-atom save!]
  (kyc-process-actions/*->complete!
   {:kyc-process-id (:db/id entity)}
   (fn [_resp]
     (swap! answers-atom dissoc :kyc-legal-entity/signature-date)
     (deref answers-atom)
     (save!))
   (fn [resp]
     (logging/error "Failed to complete KYC " resp))))

(defn view
  [_state-atom entity _save! _field-errors-atom]
  (let [template-schema (template-registry/templates (:kyc-process/template entity))]
    (fn [state-atom entity save! field-errors-atom]
      (let [lang (or (:lang @state-atom)
                     (:kyc-process/language entity))
            lang-kw (or (languages/long->short lang)
                        lang)
            available-languages-set (set (or (:kyc-template/available-languages template-schema)
                                             [:ENG :FIN]))
            hide-language-picker? (and (-> available-languages-set
                                           count
                                           (= 1))
                                       (contains? available-languages-set lang))]
        [edit-view/view
         {:state-atom state-atom
          :save!      save!
          :entity     entity
          :mandatory? true
          :read-only? false
          :lang       lang
          :field-errors-atom field-errors-atom
          :header-renderer
          (fn [state-atom _answers-atom entity]
            [:div.container.pt-4
             [:div.card--kyc
              (when-not hide-language-picker?
                [:div.card__head.px-4.pt-4
                 [:div.select-area
                  [editor
                   {:editor/type          :editor.type/select
                    :value                (or (:lang @state-atom) (:kyc-process/language entity))
                    :value-type           :keyword
                    :attribute            :lang
                    :field/not-clearable? true
                    :options kyc-process/template-language-options
                    :on-change!           (fn [_e new-value]
                                            (swap! state-atom assoc :lang new-value))
                    :on-save!             (fn [attribute new-value]
                                            (swap! state-atom assoc attribute new-value))
                    :on-blur!             (fn [_e new-value clear-cb!]
                                            (swap! state-atom assoc :lang new-value)
                                            (deref state-atom)
                                            (clear-cb!))}]]])
              [:div.card-body
               [:img.horizontal-page__body-top-logo
                {:src (fu/sanitize-img-url (:kyc-template/png-logo template-schema))}]
               [:h1
                (-> template-schema
                    :kyc-template/kyc-form-title
                    :translations
                    (get lang-kw))]]]])
          :footer-renderer
          (fn [state-atom answers-atom entity _invalid-questions]
            (let [answers (:kyc-process/answers entity)
                  missing-mandatory-fields (kvu/resolve-missing-fields lang-kw template-schema answers-atom entity)
                  validation-errors (kvu/resolve-validation-errors
                                     {:lang-kw lang-kw
                                      :template-schema template-schema
                                      :answers-atom answers-atom
                                      :field-errors-atom field-errors-atom
                                      :kyc-process entity})
                  pending-board-members (some->> @answers-atom
                                                 :kyc-legal-entity/board-members-edn
                                                 (some
                                                  (fn [bm]
                                                    (= (:kyc-board-member/confirmation-status bm)
                                                       :confirmed-by-controller)))); :confirmed-by-controller means it is pending in wip screen 

                  missing-signer-email? (template-registry/missing-signer? (:kyc-process/template entity) answers)
                  missing-mandatory-fields-desc (seq
                                                 (distinct
                                                  (concat
                                                   missing-mandatory-fields
                                                   validation-errors
                                                   (when pending-board-members
                                                     [(loc/tr :board-members-pending nil lang-kw)])
                                                   (when missing-signer-email?
                                                     [(loc/tr :missing-signer-email nil lang-kw)]))))]
              [:div.d-flex.flex-static.kyc-submit-footer
               [:div.container
                [:div.d-flex.justify-content-between
                 [kvu/exit-button entity lang-kw]
                 [kvu/reminder-button entity lang-kw]
                 (when-let [help-email (:kyc-template/help-email-address template-schema)]
                   [:div.d-flex.flex-column
                    [:span (loc/tr :kyc-wip-need-help? nil lang-kw)]
                    [:a {:href (str "mailto:" help-email)}
                     help-email]])
                 [:div
                  {:class "flex flex-row gap-2"}
                  [button/warning-solid
                   {:disabled? (or (:submitted-for-review @state-atom)
                                   missing-mandatory-fields-desc)
                    :tooltip   (when missing-mandatory-fields-desc
                                 [kvu/error-hiccup lang-kw missing-mandatory-fields-desc])
                    :on-click  (fn [_]
                                 (submit-for-review! entity state-atom))}
                   (loc/tr :submit-for-review-and-e-sign nil lang-kw)]
                  (when-not (template-registry/angel-co-investment-template? (:kyc-process/template entity))
                    [button/primary-solid
                     {:disabled? missing-mandatory-fields-desc
                      :tooltip   (when missing-mandatory-fields-desc
                                   [kvu/error-hiccup lang-kw missing-mandatory-fields-desc])
                      :on-click  (fn [_]
                                   (complete! entity answers-atom save!))}
                     (loc/tr :kyc-print-and-sign nil lang-kw)])]]]]))}]))))
